export enum ActionTypeNames {
    StartLoading = 'Navigation/StartLoading',
    EndLoading = 'Navigation/EndLoading'
}
